import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

/** White card surface: balanced border, large radius, clipped corners. Layout inside is the caller's. */
export const OrionResourceCardBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 0,
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.tokens.outlines.defaultBordersBalanced}`,
  borderRadius: `${theme.shape.borderRadiusLg}px`,
  overflow: "hidden",
}));
